export function sendStatisticsEvent(url, event) {
    const { account } = event;
    const now = new Date();
    const timestamp = event.timestamp ||
        Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate(), now.getUTCHours(), now.getUTCMinutes(), now.getUTCSeconds(), now.getUTCMilliseconds());
    return navigator.sendBeacon(url, JSON.stringify({
        eventName: event.name,
        timestamp,
        details: {
            account,
            ...event.payload,
        },
    }));
}
